<template>
    <div class="page__process">
        <div class="fader"></div>
		
		<Preloader/>
		
        <section class="process page_process">
            <div class="process__loader"></div>
            <Header class="header_black"/>
            
            <div class="content_wrapper">
                <div class="backMap">
                    <div class="backMapWrap">
                        <mapbox class="process__mapbox" :accessToken="accessToken" :map-options="options" @map-load="mapInitialized"></mapbox>
                    </div>
                </div>
                <div class="progress_box" :data-current="activeSlide+1">
                    <span class="progress_dot"></span>
                    <div class="progress_line"></div>
                    <div class="progress_shape" id="morphShape">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 214 214" style="enable-background:new 0 0 214 214;" xml:space="preserve">
                            <path d="M213,107c0,4.8-0.3,9.4-0.9,14c-0.7,5.2-1.8,10.4-3.2,15.3c-1.6,5.5-3.6,10.8-6,15.8c-2.1,4.4-4.4,8.6-7.1,12.6c-2.6,4-5.5,7.9-8.7,11.5c-2.9,3.4-6,6.5-9.3,9.5c-3.8,3.4-7.9,6.6-12.2,9.4c-4,2.7-8.3,5.1-12.7,7.2c-4.1,2-8.3,3.7-12.6,5.1c-4.3,1.4-8.7,2.6-13.3,3.5c-6.5,1.2-13.2,1.9-20.1,1.9c-4.5,0-9-0.3-13.3-0.8c-5-0.6-9.8-1.6-14.6-2.9c-4.1-1.1-8-2.5-11.9-4c-4.3-1.7-8.4-3.7-12.4-6c-3.9-2.2-7.6-4.6-11.2-7.3c-4.1-3-7.9-6.3-11.5-9.9c-3.4-3.4-6.5-6.9-9.4-10.7c-3.6-4.7-6.8-9.8-9.6-15.1c-1.6-3-3-6-4.3-9.2c-1.4-3.5-2.7-7.1-3.8-10.8c-1.5-5.1-2.6-10.4-3.2-15.8c-0.6-4.4-0.9-9-0.9-13.6c0-4.9,0.3-9.8,1-14.6c0.6-4.5,1.5-8.9,2.7-13.1c1-3.7,2.2-7.3,3.6-10.9c1.9-4.9,4.1-9.5,6.7-14c2.4-4.1,5-8.1,7.9-11.8c4.5-5.8,9.5-11.2,15-15.9c3.8-3.3,7.9-6.3,12.2-9.1c4.3-2.7,8.8-5.2,13.5-7.3c5.5-2.5,11.3-4.5,17.3-6C89.2,2.1,98,1,107,1c4.9,0,9.7,0.3,14.4,1c4.2,0.6,8.3,1.4,12.3,2.4c3.6,0.9,7.1,2,10.5,3.3c4.6,1.7,9.1,3.8,13.3,6.1c5,2.7,9.8,5.9,14.3,9.3c4.9,3.8,9.4,8,13.6,12.6c3,3.3,5.8,6.8,8.4,10.5c2.7,3.8,5.1,7.8,7.3,12c2.1,4.1,4,8.3,5.6,12.6c1.7,4.8,3.2,9.7,4.2,14.8C212.3,92.5,213,99.7,213,107z">
                                <animate id="stage_one" begin="indefinite" fill="freeze" attributeName="d" dur="500ms" to="M213,107c0,4.8-0.3,9.4-0.9,14c-0.7,5.2-1.8,10.4-3.2,15.3c-1.6,5.5-3.6,10.8-6,15.8c-2.1,4.4-4.4,8.6-7.1,12.6c-2.6,4-5.5,7.9-8.7,11.5c-2.9,3.4-6,6.5-9.3,9.5c-3.8,3.4-7.9,6.6-12.2,9.4c-4,2.7-8.3,5.1-12.7,7.2c-4.1,2-8.3,3.7-12.6,5.1c-4.3,1.4-8.7,2.6-13.3,3.5c-6.5,1.2-13.2,1.9-20.1,1.9c-4.5,0-9-0.3-13.3-0.8c-5-0.6-9.8-1.6-14.6-2.9c-4.1-1.1-8-2.5-11.9-4c-4.3-1.7-8.4-3.7-12.4-6c-3.9-2.2-7.6-4.6-11.2-7.3c-4.1-3-7.9-6.3-11.5-9.9c-3.4-3.4-6.5-6.9-9.4-10.7c-3.6-4.7-6.8-9.8-9.6-15.1c-1.6-3-3-6-4.3-9.2c-1.4-3.5-2.7-7.1-3.8-10.8c-1.5-5.1-2.6-10.4-3.2-15.8c-0.6-4.4-0.9-9-0.9-13.6c0-4.9,0.3-9.8,1-14.6c0.6-4.5,1.5-8.9,2.7-13.1c1-3.7,2.2-7.3,3.6-10.9c1.9-4.9,4.1-9.5,6.7-14c2.4-4.1,5-8.1,7.9-11.8c4.5-5.8,9.5-11.2,15-15.9c3.8-3.3,7.9-6.3,12.2-9.1c4.3-2.7,8.8-5.2,13.5-7.3c5.5-2.5,11.3-4.5,17.3-6C89.2,2.1,98,1,107,1c4.9,0,9.7,0.3,14.4,1c4.2,0.6,8.3,1.4,12.3,2.4c3.6,0.9,7.1,2,10.5,3.3c4.6,1.7,9.1,3.8,13.3,6.1c5,2.7,9.8,5.9,14.3,9.3c4.9,3.8,9.4,8,13.6,12.6c3,3.3,5.8,6.8,8.4,10.5c2.7,3.8,5.1,7.8,7.3,12c2.1,4.1,4,8.3,5.6,12.6c1.7,4.8,3.2,9.7,4.2,14.8C212.3,92.5,213,99.7,213,107z"/>
                                <animate id="stage_two" begin="indefinite" fill="freeze" attributeName="d" dur="500ms" to="M152.4,122.9c1.2,5.2,2.3,6.2,3.9,10.6c1.7,4.7,2.7,7.3,4.5,12.1c2,5.3,2.8,7.7,4.8,12.9c2.2,6,2.9,7.7,5.7,15.4c1.6,4.6,5.5,12.7,7.3,19.7c1.1,4.3,4.6,12.5,7.5,20.3c0,0-7.1,0-12.8,0c-4.9,0-10.5,0-14.8,0c-4.5,0-7.8-0.6-12.5,0c-4.5,0.6-8.5-0.9-13,0c-6.5,1.2-14.9-1-21.8-1c-4.5,0-8.7,0.9-13,0.3c-5-0.6-3.9,0.4-8.8,0.1c-4.3-0.3-6.1,0.6-10.3,0.2c-4.7-0.4-6.3,0.9-10.8,0.2c-4.5-0.7-4.8,0.2-9.3,0.2c-3.2,0-3.2,0-8.3,0c-8.5,0-22.6,0-22.6,0c2.6-5.4,1.9-4.1,3.4-9.3c0.9-3.2,14.7-39.8,15.9-43c1.6-4.3,3.2-8.6,4.5-12.2c1.7-4.7,2.5-6.8,4.4-11.9c2-5.5,2.5-7.8,4.4-12c1.5-3.3,3.1-5.5,3.8-10.3c0.6-4.5,2.8-6.5,4-10.8c1-3.7,2.2-6.1,3.6-9.7c1.9-4.9,2.2-7.5,4.5-12.1c1.3-2.6,2.9-8,4.6-12.4c1.8-4.8,2.4-6.5,4.9-13.4c1.5-4.2,4.8-12.9,6.5-17.6c2.3-6.3,6.3-16.4,7.9-21.3c1.8-5.6,3.3-9.1,5.6-15.1c1.1-2.9,2.5,1,3.2,3c2,5.4,2,5.4,3.8,10.3c1.5,4,3.3,8.8,4.4,11.8c1.3,3.5,2.4,6.6,4.1,11c1.7,4.6,1.7,4.6,3,8.2c2,5.4,0.8,4.5,3.4,9.2c3,5.4,1.6,5.8,4,10.9c1.9,4,1.1,6.4,3.7,10c2.7,3.8,0.9,4.2,3.1,8.4c2.1,4.1,2.5,6.6,4,11c1.7,4.8,3.7,7.7,4.7,12.8C148.8,116.4,150.7,115.8,152.4,122.9z"/>
                                <animate id="stage_three" begin="indefinite" fill="freeze" attributeName="d" dur="500ms" to="M197,101.8c0,4.8,0.6,15.7,0,20.3c-0.7,5.2,0,10.8,0,16.3c0,5.7,0,11.5,0,17.3c0,4.8,0,7.5,0,11.3c0,4.8,0,6.8,0,10.8c0,4.4,0,15,0,19.3c0,0-12.3,0-17.8,0c-4.9,0-12,0-18.3,0c-4.5,0-13.3-0.6-20.3,0c-4.5,0.4-13.7,0-18.3,0c-6,0-12.9,0-19.8,0c-4.5,0-15.7,0.5-20.1,0c-5-0.6-16.5,0.8-22.6,0c-4.2-0.6-10,0-15.3,0c-4.6,0-10.3,0-14,0c-4.5,0-13.6,1.5-13.6,0c0-5.1,0-10.5,0-16.5c0-4.8,0-4.8,0-8.8c0-5.9,0-7,0-12.3c0-3.4,0-6.8,0-10c0-3.8,0-9.5,0-14c0-5.3,0.7-8.9,0-14.3c-0.6-4.4,0-9,0-13.6c0-4.9-0.7-10.5,0-15.3c0.6-4.5,0-10.9,0-15.3c0-4.3-0.6-5.8,0-9.5c0.8-5,0-7.9,0-13c0-4-0.4-6.1,0-10.8c0.5-5.8,0-2,0-9.3c0-3.9,0-3.9,0-9c0-3.8,0-4.7,0-8.3c0-1.7,14.6,0,23.8,0c8.6,0,18.3,0,27.3,0c4.9,0,31.9-0.6,36.6,0c4.2,0.6,23.1,0,27.6,0c3.7,0,26.3,0,31.3,0c4.9,0,33.4-1.4,33.4,0c0,5.7,0,12.1,0,16.8c0,6.2,0,6.2,0,9.8c0,4.5,0,5.5,0,9.3c0,4.7,0,5.8,0,9.3c0,4.6,0,9,0,14c0,5.1,0,7.1,0,12.3C197,96.6,197,94.4,197,101.8z"/>
                                <animate id="stage_four" begin="indefinite" fill="freeze" attributeName="d" dur="500ms" to="M197,101.8c0.3,4.8-0.4,13.7-1,18.3c-0.7,5.2-2.3,12.2-4.4,17.3c-1.9,4.9-2.1,6.1-4.9,11.1c-2.6,4.7-3.6,6.5-5.8,9.6c-3.4,4.6-3.8,5.9-6.8,8.6c-3.7,3.4-3.7,3.4-6.1,6.2c0,0-1.8,2-6.2,5.2c-2.8,2.1-1.8,1.6-6.8,4.8c-3.8,2.4-6.7,4.4-13.3,6.9c-4.8,1.8-10.4,4.1-18.2,5.4c-5.9,1-14.1,1.7-21,1.7c-4.5,0-15.7,0.5-20.1,0c-5-0.6-16.5,0.8-22.6,0c-4.2-0.6-10,0-15.3,0c-4.6,0-10.3,0-14,0c-4.5,0-13.6,1.5-13.6,0c0-5.1,0-10.5,0-16.5c0-4.8,0-4.8,0-8.8c0-5.9,0-7,0-12.3c0-3.4,0-6.8,0-10c0-3.8,0-9.5,0-14c0-5.3,0.7-8.9,0-14.3c-0.6-4.4,0-9,0-13.6c0-4.9-0.7-10.5,0-15.3c0.6-4.5,0-10.9,0-15.3c0-4.3-0.6-5.8,0-9.5c0.8-5,0-7.9,0-13c0-4-0.4-6.1,0-10.8c0.5-5.8,0-2,0-9.3c0-3.9,0-3.9,0-9c0-3.8,0-4.7,0-8.3c0-1.7,14.6,0,23.8,0c8.6,0,18.3,0,27.3,0c4.9,0,31.9,0.1,36.6,0c5.3-0.2,12.3,0.3,16.8,1c4.4,0.7,8.9,2.2,13.8,3.4c5.2,1.3,13.8,5.8,15,6.5c4.1,2.4,7.7,4.5,11.4,7.5c3.2,2.6,5.5,4.3,8,6.9c2.9,2.9,6.1,6.3,8.3,9.3c2.3,3,4.6,6.2,6.3,9.3c2.5,4.5,3.6,5.9,5.4,10.5c2.1,5.5,3.9,10.5,5.1,15.6C196.2,93.2,196.6,94.7,197,101.8z"/>
                                <animate id="stage_five" begin="indefinite" fill="freeze" data-spin="true" attributeName="d" dur="500ms" to="M197,101.8c0,4.8,0.6,15.7,0,20.3c-0.7,5.2,0,10.8,0,16.3c0,5.7,0,11.5,0,17.3c0,4.8,0,7.5,0,11.3c0,4.8,0,6.8,0,10.8c0,4.4,0,15,0,19.3c0,0-12.3,0-17.8,0c-4.9,0-12,0-18.3,0c-4.5,0-13.3-0.6-20.3,0c-4.5,0.4-13.7,0-18.3,0c-6,0-12.9,0-19.8,0c-4.5,0-15.7,0.5-20.1,0c-5-0.6-16.5,0.8-22.6,0c-4.2-0.6-10,0-15.3,0c-4.6,0-10.3,0-14,0c-4.5,0-13.6,1.5-13.6,0c0-5.1,0-10.5,0-16.5c0-4.8,0-4.8,0-8.8c0-5.9,0-7,0-12.3c0-3.4,0-6.8,0-10c0-3.8,0-9.5,0-14c0-5.3,0.7-8.9,0-14.3c-0.6-4.4,0-9,0-13.6c0-4.9-0.7-10.5,0-15.3c0.6-4.5,0-10.9,0-15.3c0-4.3-0.6-5.8,0-9.5c0.8-5,0-7.9,0-13c0-4-0.4-6.1,0-10.8c0.5-5.8,0-2,0-9.3c0-3.9,0-3.9,0-9c0-3.8,0-4.7,0-8.3c0-1.7,14.6,0,23.8,0c8.6,0,18.3,0,27.3,0c4.9,0,31.9-0.6,36.6,0c4.2,0.6,23.1,0,27.6,0c3.7,0,26.3,0,31.3,0c4.9,0,33.4-1.4,33.4,0c0,5.7,0,12.1,0,16.8c0,6.2,0,6.2,0,9.8c0,4.5,0,5.5,0,9.3c0,4.7,0,5.8,0,9.3c0,4.6,0,9,0,14c0,5.1,0,7.1,0,12.3C197,96.6,197,94.4,197,101.8z"/>
                                <animate id="stage_six" begin="indefinite" fill="freeze" data-spin="true" attributeName="d" dur="500ms" to="M197,101.8c0,4.8,0.6,15.7,0,20.3c-0.7,5.2,0,10.8,0,16.3c0,5.7,0,11.5,0,17.3c0,4.8,0,7.5,0,11.3c0,4.8,0,6.8,0,10.8c0,4.4,0,15,0,19.3c0,0-6.2-6.2-11.5-11.5c-3.4-3.4-7-7-11.5-11.5c-3.2-3.2-5.8-5.8-8.8-8.8c-3.2-3.2-6.5-6.5-9.5-9.5c-4.3-4.3-5.5-5.5-8.8-8.8c-3.2-3.2-4.7-4.7-7.8-7.8c-3.5-3.5-4.7-4.7-7.8-7.8c-3-3-3-3-5.8-5.8c-3.3-3.3-4.8-4.8-7.5-7.5c-3.2-3.2-5.6-5.6-6.7-6.7c-2.5-2.5-2.5-2.5-4-4.2c-3.2-3.5-4-2.8-6.6-6.5c-3.4-4.8-3.8-3-7-7c-2.1-2.6-3.8-2.9-6.7-6.7c-2.3-3-3.3-2.3-6.5-6.5C77.1,76.1,77.4,78,74,74c-2.9-3.4-2.9-3.4-5.3-5.3c-3.9-3.1,0,0-4.2-4.2c-3.2-3.2-3.2-3.2-6.2-6.2c-3-3-4-4-7.2-7.2c-3.6-3.6-3.6-3.6-7.5-7.5c-2.8-2.8-3.8-3.8-7.3-7.3c-4.1-4.1-4.1-4.1-7.5-7.5c-2.8-2.8-2.8-2.8-6-6C20.2,20.2,17,17,17,17c0-1.7,14.6,0,23.8,0c8.6,0,18.3,0,27.3,0c4.9,0,31.9-0.6,36.6,0c4.2,0.6,23.1,0,27.6,0c3.7,0,26.3,0,31.3,0c4.9,0,33.4-1.4,33.4,0c0,5.7,0,12.1,0,16.8c0,6.2,0,6.2,0,9.8c0,4.5,0,5.5,0,9.3c0,4.7,0,5.8,0,9.3c0,4.6,0,9,0,14c0,5.1,0,7.1,0,12.3C197,96.6,197,94.4,197,101.8z"/>
                            </path>

                        </svg>
                    </div>
                    <div class="process_indicator" :data-current="activeSlide+1">
                        <span class="proc_indic_item" data-state="1">01</span>
                        <span class="proc_indic_item" data-state="2">02</span>
                        <span class="proc_indic_item" data-state="3">03</span>
                        <span class="proc_indic_item" data-state="4">04</span>
                        <span class="proc_indic_item" data-state="5">05</span>
                        <span class="proc_indic_item" data-state="6">06</span>
                    </div>
                </div>
                <div class="carousel">
                    <div class="swiper_navigation">
                        <div class="swiper-button-prev icon-left_arrow" id="process_prev"></div>
                        <div class="swiper-button-next icon-right_arrow" id="process_next"></div>
                    </div>
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide data-history="Discovery">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.discovery') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.discovery_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="Import">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.import') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.import_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="Pre-sales_service">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.pre_sales') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.pre_sales_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="Distribution">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.distribution') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.distribution_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="Marketing_support">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.marketing') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.marketing_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="After-sales_service">
                            <div class="slide_content_box">
                                <span class="carousel_indicator">&nbsp;</span>
                                <div class="carousel__name"><span class="textHideSlide"><span>{{ $t('pipeline.after_sales') }}</span></span></div>
                                <div class="carousel__desc"><span class="textHideSlideP"><span>{{ $t('pipeline.after_sales_descr') }}</span></span></div>
                            </div>
                        </swiper-slide>
                        <swiper-slide data-history="Join_in">
                            <div class="slide_content_box">
                                <div class="carousel__name join__title"><span class="textHideSlide"><span>{{ $t('header.join') }}</span></span></div>
                                <div class="carousel__desc join__box">
                                    <Join/>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="navigation">
                        <div class="navigation__item fadeChain" :data-unit="index+1" v-for="(item, index) in navigationItems" :key="item" @click="goTo(index)" :class="{ 'navigation__item_active' : index === activeSlide }">
                            <span class="navigation__indicator">0{{index+1}}</span>
                            <div class="navigation__name">{{ $t('pipeline.'+item) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Join from '@/components/join_block.vue'
	import Preloader from '@/components/preloader.vue'
    import Mapbox from 'mapbox-gl-vue';
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    

    export default {
        ComponentName: 'process',
        data() {
            return {
                accessToken: 'pk.eyJ1IjoidGF5YXEiLCJhIjoiY2pqNWttc3pnMDF5YTNrcGZ2MjgxdnJmcSJ9.FYBtnxzTWi0BhKf4d0xyog',
                options: {
                    style: 'mapbox://styles/tayaq/cjjsub2g102xu2so7bzyat5k5',
                    center: [32, 49.5],
                    zoom: 3.5,
                    attributionControl: false
                },
                activeSlide: 0,
                navigationItems: ['discovery', 'import', 'pre_sales', 'distribution', 'marketing', 'after_sales'],
                morphIndex: ['stage_one', 'stage_two', 'stage_three', 'stage_four', 'stage_five', 'stage_six', ''],
                mapZoom: ['3.5', '4.5', '5.5', '6.5', '7.5', '8.5', '3'],
                scrolled: false,
                params: {
                    state: ''
                },
                swiperOption: {
                    slidesPerView: 1,
                    mousewheel: true,
                    direction: 'horizontal',
                    effect: 'fade',
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false,
                    },
                    navigation: {
                        nextEl: '#process_next',
                        prevEl: '#process_prev'
                    },
                    breakpoints: {
                        1023: {
                            direction: 'vertical'
                        }
                    },
                    on: {
                        init: function() {
                            setTimeout(function() {
                                $('.swiper-slide-active').addClass('visibleSlide');
                            }, 1000);
                        },
                        slideChangeTransitionStart: function() {
                            $('.visibleSlide').removeClass('visibleSlide');
                        },
                        slideChangeTransitionEnd: function() {
                            $('.swiper-slide-active').addClass('visibleSlide');
                        }
                    }
                },
                onSlideChangeEnd: function() {
                    this.onSwipe()
                }
            }
        },
        components: {
            Header,
            Mapbox,
            swiper,
            swiperSlide,
            Join,
			Preloader
        },
        methods: {
            mapInitialized(map) {
                this.map = map;
                
                document.body.classList.add('startAnim');
            },
            goTo(index) {
                this.swiper.slideTo(index);
            },
            onSwipe(obj) {
                this.activeSlide = obj.swiper.activeIndex;
                this.map.flyTo({
                    zoom: this.mapZoom[obj.swiper.activeIndex],
                    center: [32, 49.5]
                })
                
                var animationToCheck = document.getElementById(this.morphIndex[obj.swiper.activeIndex]);
                if(animationToCheck) {
                    var isSpin = animationToCheck.getAttribute('data-spin'),
                        par = document.getElementById('morphShape');
                    animationToCheck.beginElement();

                    if(isSpin) 
                        par.classList.add('needSpin');
                    else
                        par.classList.remove('needSpin');
                }
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        mounted() {
            this.swiper.on('slideChange',()=>{
                this.onSwipe(this)
            });
            
            $('body').removeClass('lightBack hideTopBar').addClass('processPage pPage');
        },
        beforeDestroy() {
            $('body').removeClass('processPage startAnim');
        }
    }
    
    document.body.classList.remove('lightBack');
    document.body.classList.remove('scrolledPage');
</script>

<style lang="stylus">
    .VueCarousel-wrapper
        height 100%

    .VueCarousel-inner
        height 100%
</style>

<style lang="stylus" scoped>
    .backMap
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        overflow hidden
        z-index 1
        
    .backMapWrap
        width 100%
        height 100%
        position absolute
        top 0
        left 0
    
    .swiper_navigation
        position absolute
        top auto
        bottom 80px
        left 50px
        height 80px
        
        @media (max-height 560px)
            bottom 0
        
        @media (min-width 700px)
            left 200px
        
        @media (min-width 1024px)
            top calc(50% - 60px)
            bottom auto
            left 80px
            height auto
    
    #process_prev
        width 40px
        height 40px
        top 0
        right auto
        left 0
        background none
        margin 0
        font-size 14px
        color #C6C8CC
        text-align center
        line-height 40px
        outline none
        -webkit-transform rotate(90deg)
        -moz-transform rotate(90deg)
        transform rotate(90deg)
        
        @media (min-width 1024px)
            -webkit-transform rotate(0deg)
            -moz-transform rotate(0deg)
            transform rotate(0deg)
        
        &:hover
            color #fff
        
    #process_next
        width 40px
        height 40px
        top 40px
        right auto
        left 0
        background none
        margin 0
        font-size 14px
        color #C6C8CC
        text-align center
        line-height 40px
        outline none
        -webkit-transform rotate(90deg)
        -moz-transform rotate(90deg)
        transform rotate(90deg)
        
        @media (min-width 1024px)
            left 40px
            top 0
            -webkit-transform rotate(0deg)
            -moz-transform rotate(0deg)
            transform rotate(0deg)
        
        &:hover
            color #fff
    
    .swiper-button-disabled
        opacity .5
            
    .swiper-container
        height 100%
    
    .swiper-slide:not(.swiper-slide-active)
        opacity 0 !important
    
    .process
        width 100%
        height 100vh
        position relative
        overflow hidden
        
        @media (min-width 1024px)
            height 100%
        
    .process__mapbox
        position absolute
        left -12%
        top -12%
        width 124%
        height 124%
        z-index -1

    .carousel
    .carousel__body
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        z-index 5

    .carousel__item
        min-height 100%
        padding 48px 80px
        box-sizing border-box

    .slide_content_box 
        padding 0 20px 0 50px
        position relative
        top 150px
        
        @media (min-width 700px)
            padding 0 35px 0 200px
            top 230px
        
        @media (min-width 1024px)
            padding 0 0 0 325px
            top calc(50% - 90px)
    
    .carousel__name
        font-size 24px
        color #fff
        margin-bottom 10px
        position relative

        @media (min-width 1024px)
            margin-bottom 24px

    .carousel__desc
        color #808080
        font-size 18px
        line-height 160%
        padding-top 15px
        max-width 300px
        
        @media (min-width 1024px)
            max-width 360px
            line-height 180%
            padding-top 24px
        
    .carousel__desc.join__box 
        max-width 100%
        
    .navigation
        position absolute
        left 0
        bottom 0
        width calc(100% - 150px)
        padding 0 75px
        height 75px
        display none
        justify-content center
        z-index 20
        background url('../assets/images/svg/dots.svg') center top repeat-x
        
        @media (min-width 1024px)
            display flex

    .navigation__item
        display flex
        justify-content center
        flex-direction column
        color #fff
        width 16.66%
        padding 0 10px
        cursor pointer
        position relative
        z-index 1

    .navigation__indicator
        display block
        font-size 12px
        color #808080

    .navigation__name
        font-size 14px
        color #fff
    
    .navigation__item
        &:after
            content ''
            position absolute
            bottom 0
            left 0
            background #808080
            width 100%
            height 4px
            opacity 0
            -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
            transition all .3s cubic-bezier(.25,.01,.25,1)

    .navigation__item:not(.navigation__item_active):hover
        &:after
            opacity 1
            bottom 0
    
    .navigation__item_active
        z-index 2
        
    .navigation__item_active
        .navigation__indicator, .navigation__name
            text-indent: 10px

    .navigation__item
        &:before
            content ''
            position absolute
            bottom -12px
            background #141414
            z-index -1
            -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
            transition all .3s cubic-bezier(.25,.01,.25,1)
            width 100%
            height 0
            padding-top 12px
            right 0
            opacity 0
            
    .navigation__item
        .navigation__indicator, .navigation__name
            -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition .3s cubic-bezier(.25,.01,.25,1)
            transition .3s cubic-bezier(.25,.01,.25,1)
    
    .navigation__item_active
        &:before
            height 100%
            opacity 1
            bottom 0
            
    .carousel_indicator 
        position relative
        font-size 12px
        color #808080
        padding-bottom 5px
        left 0
        
        @media (min-width 1024px)
            left -20px
        
    .progress_box 
        width 100%
        height 100%
        position absolute
        top 0
        left 0
        z-index 2

    .progress_dot
        width 7px
        height 7px
        position absolute
        top 190px
        left 22px
        background #4E4E4D
        display block
        -webkit-border-radius 100%
        -moz-border-radius 100%
        border-radius 100%
        z-index 3
        
        @media (min-width 700px)
            top 270px
            left 160px
        
        @media (min-width 1024px)
            left 322px
            top calc(50% - 7px)
        
    .progress_line
        width 1px
        height 100%
        position absolute
        top 0
        left 25px
        background url('../assets/images/svg/vert_dots.svg') left top repeat-y
        z-index 1
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
        
        @media (min-width 700px)
            left 163px
        
        @media (min-width 1024px)
            width 100%
            height 1px
            top calc(50% - 4px)
            left 0
            background url('../assets/images/svg/dots.svg') center top repeat-x
       
    .progress_box[data-current="1"] .progress_line
        width 1px
        height calc(100% - 190px)
        left 25px
        top 190px
        
        @media (min-width 700px)
            left 163px
            height calc(100% - 270px)
            top 270px
        
        @media (min-width 1024px)
            width calc(100% - 325px)
            height 1px
            left 325px
            top calc(50% - 4px)
 
    .progress_box[data-current="7"] .progress_line
        width 1px
        height 190px
        
        @media (min-width 700px)
            height 270px
        
        @media (min-width 1024px)
            width 325px
            height 1px

    .progress_shape 
        width 214px
        height 214px
        position absolute
        top 83px
        left -82px
        z-index 2
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
        
        @media (min-width 700px)
            top 163px
            left 56px
        
        @media (min-width 1024px)
            top calc(50% - 111px)
            left 218px
        
    .progress_box[data-current="7"] .progress_shape
        opacity 0

    .progress_shape.needSpin
        -webkit-transform rotate(45deg)
        -moz-transform rotate(45deg)
        transform rotate(45deg)
        
    .progress_shape svg
        width 100%
        height 100%
        
    .progress_shape svg path
        stroke #fff
        stroke-width 1px
        stroke-miterlimit 10
        fill none
        stroke-dasharray 1,9
        opacity .5
        
    .join__title
        font-size 36px
        color #fff
        font-weight bold

        @media (min-width 1024px)
            font-size 48px
        
    .backBtn
        position absolute
        top 38px
        left 325px
        z-index 110
        font-size 14px
        font-weight 600
        color #808080
        
        &:before
            content ''
            width 0
            height 0
            border-style solid
            border-width 3px 3px 0 3px
            border-color transparent transparent #808080 transparent
            margin-left 4px
        
    .content_wrapper 
        background none
        
    .process_indicator
        width: 20px
        height 16px
        position absolute
        top 150px
        left 50px
        overflow hidden
        
        @media (min-width 700px)
            top 230px
            left 200px
        
        @media (min-width 1024px)
            top calc(50% - 85px)
            left 305px
       
    .proc_indic_item
        width 100%
        height 100%
        position absolute
        top 100%
        left 0
        display block
        font-size 12px
        font-weight bold
        color #808080
        -webkit-transition .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition .3s cubic-bezier(.25,.01,.25,1)
        transition .3s cubic-bezier(.25,.01,.25,1)

    .process_indicator[data-current="1"]
        [data-state="1"]
            opacity 1
            top 0
            
    .process_indicator[data-current="2"]
        [data-state="2"]
            opacity 1
            top 0
            
        [data-state="1"]
            top -100%
            
    .process_indicator[data-current="3"]
        [data-state="3"]
            opacity 1
            top 0
            
        [data-state="1"], [data-state="2"]
            top -100%
            
    .process_indicator[data-current="4"]
        [data-state="4"]
            opacity 1
            top 0
            
        [data-state="1"], [data-state="2"], [data-state="3"]
            top -100%
            
    .process_indicator[data-current="5"]
        [data-state="5"]
            opacity 1
            top 0
            
        [data-state="1"], [data-state="2"], [data-state="3"], [data-state="4"]
            top -100%
            
    .process_indicator[data-current="6"]
        [data-state="6"]
            opacity 1
            top 0
            
        [data-state="1"], [data-state="2"], [data-state="3"], [data-state="4"], [data-state="5"]
            top -100%
            
    .process_indicator[data-current="7"]   
        [data-state="1"], [data-state="2"], [data-state="3"], [data-state="4"], [data-state="5"], [data-state="6"]
            top -100%
            
    

    /* process animation */
    .textHideSlide
        display block
        overflow hidden

        span
            position relative
            top 70px
            -webkit-transition .5s cubic-bezier(.25,.01,.25,1)
            -moz-transition .5s cubic-bezier(.25,.01,.25,1)
            transition .5s cubic-bezier(.25,.01,.25,1)

    .textHideSlideP
        display block
        overflow hidden

        span
            position relative
            top -120px
            opacity 0
            -webkit-transition .5s cubic-bezier(.25,.01,.25,1)
            -moz-transition .5s cubic-bezier(.25,.01,.25,1)
            transition .5s cubic-bezier(.25,.01,.25,1)
    
    .fadeChain
        top 50px
        opacity 0
        -webkit-transition .2s cubic-bezier(.25,.01,.25,1)
        -moz-transition .2s cubic-bezier(.25,.01,.25,1)
        transition .2s cubic-bezier(.25,.01,.25,1)
            
    .startAnim
        .visibleSlide
            .textHideSlide
                span
                    top 0
                    
            .textHideSlideP
                span
                    top 0
                    opacity 1

        .fadeChain
            top 0
            opacity 1
            
        [data-unit="1"]
            -webkit-transition-delay .8s
            -moz-transition-delay .8s
            transition-delay .8s

        [data-unit="2"]
            -webkit-transition-delay .9s
            -moz-transition-delay .9s
            transition-delay .9s
            
        [data-unit="3"]
            -webkit-transition-delay 1s
            -moz-transition-delay 1s
            transition-delay 1s

        [data-unit="4"]
            -webkit-transition-delay 1.1s
            -moz-transition-delay 1.1s
            transition-delay 1.1s

        [data-unit="5"]
            -webkit-transition-delay 1.2s
            -moz-transition-delay 1.2s
            transition-delay 1.2s

        [data-unit="6"]
            -webkit-transition-delay 1.3s
            -moz-transition-delay 1.3s
            transition-delay 1.3s
        
        
        
        
        
        
        
        
            
        
        
</style>
